export default __webpack_public_path__ + "static/media/sparkles-no-1.c2993383.ogg";